/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CredentialType } from './CredentialType';
import {
    CredentialTypeFromJSON,
    CredentialTypeFromJSONTyped,
    CredentialTypeToJSON,
    CredentialTypeToJSONTyped,
} from './CredentialType';
import type { PasswordCredentialParams } from './PasswordCredentialParams';
import {
    PasswordCredentialParamsFromJSON,
    PasswordCredentialParamsFromJSONTyped,
    PasswordCredentialParamsToJSON,
    PasswordCredentialParamsToJSONTyped,
} from './PasswordCredentialParams';

/**
 * 
 * @export
 * @interface ExportedPasswordCredential
 */
export interface ExportedPasswordCredential {
    /**
     * The ID of the credential
     * @type {string}
     * @memberof ExportedPasswordCredential
     */
    id: string;
    /**
     * The time when the credential was last used to authenticate successfully
     * @type {Date}
     * @memberof ExportedPasswordCredential
     */
    last_used?: Date;
    /**
     * 
     * @type {CredentialType}
     * @memberof ExportedPasswordCredential
     */
    type: CredentialType;
    /**
     * 
     * @type {PasswordCredentialParams}
     * @memberof ExportedPasswordCredential
     */
    params: PasswordCredentialParams;
    /**
     * 
     * @type {string}
     * @memberof ExportedPasswordCredential
     */
    label?: string;
}



/**
 * Check if a given object implements the ExportedPasswordCredential interface.
 */
export function instanceOfExportedPasswordCredential(value: object): value is ExportedPasswordCredential {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('params' in value) || value['params'] === undefined) return false;
    return true;
}

export function ExportedPasswordCredentialFromJSON(json: any): ExportedPasswordCredential {
    return ExportedPasswordCredentialFromJSONTyped(json, false);
}

export function ExportedPasswordCredentialFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExportedPasswordCredential {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'last_used': json['last_used'] == null ? undefined : (new Date(json['last_used'])),
        'type': CredentialTypeFromJSON(json['type']),
        'params': PasswordCredentialParamsFromJSON(json['params']),
        'label': json['label'] == null ? undefined : json['label'],
    };
}

export function ExportedPasswordCredentialToJSON(json: any): ExportedPasswordCredential {
    return ExportedPasswordCredentialToJSONTyped(json, false);
}

export function ExportedPasswordCredentialToJSONTyped(value?: ExportedPasswordCredential | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'last_used': value['last_used'] == null ? value['last_used'] : value['last_used'].toISOString(),
        'type': CredentialTypeToJSON(value['type']),
        'params': PasswordCredentialParamsToJSON(value['params']),
        'label': value['label'],
    };
}

